import { render, staticRenderFns } from "./SwitchWithLabel.vue?vue&type=template&id=3da17e87&scoped=true"
import script from "./SwitchWithLabel.vue?vue&type=script&lang=ts"
export * from "./SwitchWithLabel.vue?vue&type=script&lang=ts"
import style0 from "./SwitchWithLabel.vue?vue&type=style&index=0&id=3da17e87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da17e87",
  null
  
)

export default component.exports